<script>
import axios from 'axios'

const name = 'zxc123';

function copy(value){
  if(value){
    return JSON.parse(JSON.stringify(value))
  } else {
    return null
  }
}

function toCDB(value){
  var tmp = ""; 
  for(var i=0;i<value.length;i++){ 
    if (value.charCodeAt(i) == 12288){
      tmp += String.fromCharCode(value.charCodeAt(i)-12256);
      continue;
    }
    if(value.charCodeAt(i) > 65280 && value.charCodeAt(i) < 65375){ 
      tmp += String.fromCharCode(value.charCodeAt(i)-65248); 
    } 
    else{ 
      tmp += String.fromCharCode(value.charCodeAt(i)); 
    } 
  }
  return tmp 
}

function jsonConcat(o1, o2){
  for (var key in o2) {
    o1[key] = o2[key];
  }
  return o1;
}

function checkForm(list, requiredField){
  let result = true
  for(var key of requiredField){
    if(!list[key]){
      result = false
    }
  }
  return result
}
async function checkIdCard(value){
  let res
  var request = {
    method: 'POST',
    url: '/common/checkIdCard',
    params: {
      IdCard: value,
    }
  }
  await axios(request)
    .then(function(response) {
      res = response.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function checkPassport(value){
  let res
  var request = {
    method: 'POST',
    url: '/common/checkPassport',
    params: {
      card: value,
    }
  }
  await axios(request)
    .then(function(response) {
      res = response.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}


async function getCountryList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/common/countryList',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      // console.log("[Global] response: " + response)
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getTypeList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/common/typevByCategory/questionType',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getCategoryList(){
  let res = []
  var request = {
    method: 'GET',
    url: '/common/typevByCategory/category',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

async function getYear(){
  let res = []
  var request = {
    method: 'GET',
    url: '/common/typevByCategory/year',
    params: {},
  }
  await axios(request)
    .then(function(response) {
      res = response.data.data[0].valuev
    }).catch(()=>{
    }).finally(()=>{
    })
  return res
}

export default
{
  name, //this.$Global.name

  //
  copy,
  toCDB,
  jsonConcat,
  checkForm,

  //[API]
  checkIdCard,
  checkPassport,
  getCountryList,
  getTypeList,
  getCategoryList,
  getYear,
}
</script>